<template>

  <div>

    <div class="title-button">
      <h1>
        Brochure: {{ brochureResponse.brochures_names }}
      </h1>
      <div v-if="!brochureResponse.customer">
        <button  type="button" class="button me-3" @click="customerFromBrochureRequest"><span>Create Customer From Requester</span></button>
        <button  type="button" class="ms-auto button" @click="showCustomerModal = true"><span>Link Customer</span></button>
      </div>
    </div>

    <div class="box">

      <form class="form brochure_request_edit" v-on:submit.prevent="updateBrochure">
        <Errors/>
          <fieldset>
            <div class="form-wrap">

              <!-- <div>
                <label for="brochure_name">Brochure</label>
                <input type="text" id="brochure_name" v-model="brochureResponse.brochures_names" disabled>
              </div> -->

              <div>
                <label for="customer">Customer</label>
                <input v-if="brochureResponse.customer" type="text" id="customer" :value="brochureResponse.customer.first_name + ' ' + brochureResponse.customer.last_name" disabled>
                <span v-else>-</span>
              </div>

              <div>
                <label for="batch_id">Batch ID</label>
                <input v-if="brochureResponse.batch_id" type="text" id="batch_id" v-model="brochureResponse.batch_id" disabled>
                <span v-else>-</span>
              </div>

              <div v-if="brochureResponse.brochure_requester">
                <label for="requester_first_name">Requester First Name</label>
                <input id="requester_first_name" type="text" :value="brochureResponse.brochure_requester.first_name" disabled>
              </div>

              <div v-if="brochureResponse.brochure_requester">
                <div>
                  <label for="requester_last_name">Requester Last Name</label>
                  <input id="requester_last_name" type="text" :value="brochureResponse.brochure_requester.last_name" disabled>
                </div>

              </div>

              <div v-if="brochureResponse.brochure_requester">
                <div>
                  <label for="requester_email">Requester Email</label>
                  <input  v-if="brochureResponse.brochure_requester && brochureResponse.brochure_requester.email" id="requester_email" type="text" :value="brochureResponse.brochure_requester.email" disabled>
                  <span v-else>-</span>
                </div>
              </div>

              <div v-if="brochureResponse.brochure_requester">
                <div>
                  <label for="requester_address">Requester address</label>
                  <span>
                    <p class="mb-0 d-inline-block" v-if="brochureResponse.brochure_requester.street_address">{{ brochureResponse.brochure_requester.street_address }}&nbsp;</p>
                    <p class="mb-0 d-inline-block" v-if="brochureResponse.brochure_requester.address_line_2">{{ brochureResponse.brochure_requester.address_line_2 }}&nbsp;</p>
                    <p class="mb-0 d-inline-block" v-if="brochureResponse.brochure_requester.town">{{ brochureResponse.brochure_requester.town }}&nbsp;</p>
                    <p class="mb-0 d-inline-block" v-if="brochureResponse.brochure_requester.county">{{ brochureResponse.brochure_requester.county }}&nbsp;</p>
                    <p class="mb-0 d-inline-block" v-if="brochureResponse.brochure_requester.postcode">{{ brochureResponse.brochure_requester.postcode }}</p>
                  </span>
                </div>
              </div>

            </div>
        </fieldset>
      </form>

    </div>
   <!-- Brochure Request Export Modal -->
    <div class="modal" v-if="showCustomerModal">
      <h1>Select Customer</h1>
      <div class="box">

        <div class="table__header">

          <form @submit.stop.prevent="doSearch" class="box__header form--inline">
            <input v-model="quickSearch" type="search" placeholder="Quick search">
            <button class="button button--small" type="submit"><span>Search</span></button>
          </form>
        </div>

        <vdtnet-table
          ref="table"
          :fields="fields"
          :opts="options"
          @link="linkCustomer"
          >
        </vdtnet-table>

      </div><!-- box -->
      <button type="button" class="icon icon--unlink" @click="showCustomerModal = false">Close</button>
    </div>
  </div>

</template>

<script>
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'BrochureEdit',
  components: {
    Errors,
    VdtnetTable
  },
  data () {
    return {
      errors: null,
      brochureResponse: {},
      showCustomerModal: false,
      options: {
        ajax: {
          url: this.$api + 'customers/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        last_name: {
          label: 'Last Name',
        },
        first_name: { label: 'First Name' },
        email: { label: 'Email',
          render: (data) => {
            return (data !== null ? `<a target="_blank" href="mailto://${ data }">${ data }</a>` : '')
          }
        },
        phone_number: { label: 'Telephone'},
        postcode: { label: 'Postcode'},
        actions: {
          searchable: false,
          sortable: false,
          label: 'Action',
          render: () => {
            return `<a href="javascript:void(0);" data-action="link" class="">Link</a>`
          }
        }
      },
      quickSearch: ''
    }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
  },
  created () {
    this.getBrochure()
  },
  watch: {
    '$route': 'getBrochure'
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    getBrochure () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'brochures/requests/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.brochureResponse = response.data[0];
        this.$store.dispatch('setLoadStatus')
      })
    },
    linkCustomer(data) {
      this.$dialog
      .confirm('Are you sure you want to link customer with brochure?')
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'brochures/requests/' + this.$route.params.id + '/link-customer', {
          method: 'POST',
          body: JSON.stringify({'customer_id' : data.id}),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.showCustomerModal = false;
            this.getBrochure();
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      })
      .catch(() => {
        console.log('Clicked on cancel');
      });
    },
    customerFromBrochureRequest() {
      this.$dialog
      .confirm({
        title: "Are you sure you want to create a new customer?",
        body: "HEADS UP: Before creating a new customer out of this brochure request, please make sure if a customer already exists, and in that case you can link that customer only to prevent duplication.",
      })
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'brochures/requests/' + this.$route.params.id + '/create-customer', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          console.log(response, 'res')
          this.$store.dispatch('setLoadStatus')
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$router.push({ name: 'customer-edit', params: { id: response.data }})
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
      })
      .catch(() => {
        console.log('clicked on cancel');
      });
    },
    updateBrochure () {
      return false;
    },
  },
}
</script>
<style scoped>
.brochure_request_edit label {
  font-weight: bold;
}

.brochure_request_edit input:disabled {
  padding: 0;
}
</style>
